export default __webpack_public_path__ + "static/media/PH-B725.8eb75b2d.webp";